import { httpInstance } from '@/services/httpInstance';

const updateCategoriesPaymentService = async (dataParam) => {
  let res;
  const endpoint = '/back-office/v1/beneficiary-catalog';
  const dataSent = dataParam;

  await httpInstance.put(
    endpoint,
    dataSent,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default updateCategoriesPaymentService;
